import {ConfirmationModal as Modal} from "../../../../../elements/v2/modals";
import React, {useCallback, useEffect, useState} from "react";
import {PROMPT_MODAL_CONFIRMATION_DELETE} from "../../PromptManagementSystemConstants";

export const ConfirmDeletePromptModal = ({ isOpen, onConfirm }) => {
  const [openModal, setOpenModal] = useState(isOpen);

  useEffect(() => {
    setOpenModal(isOpen);
  }, [isOpen]);
  
  const onHandleClose = useCallback(() => {
    setOpenModal(false);
    onConfirm && onConfirm(false);
  }, [onConfirm]);

  const onHandleConfirm = useCallback(() => {
    setOpenModal(false);
    onConfirm && onConfirm(true);
  }, [onConfirm]);
  
  return (
    <Modal
      isOpen={openModal}
      title={PROMPT_MODAL_CONFIRMATION_DELETE.title}
      message={PROMPT_MODAL_CONFIRMATION_DELETE.message}
      showIcon={false}
      isExtended={true}
      onConfirm={() => onHandleConfirm()}
      onClose={() => onHandleClose()}
      onCancel={() => onHandleClose()}
      onConfirmLabel="Continue"
    />
  );
};
